import set from 'lodash/set';

import api from '@/lib/api';

export default {
  async getSingle({ commit, rootState }, customer) {
    const { companyId: company } = rootState.auth;

    const { user, rfc, ...data } = await api.employees.getSingleByCompany(company, customer);

    let payload = { ...rfc, ...user, ...data };
    payload = Object.keys(payload).reduce((accum, key) => {
      if (payload[key]) set(accum, key, payload[key]);
      else set(accum, key, null);
      return accum;
    }, {});

    commit('setValues', payload);

    return payload;
  },

  async deleteSingle({ rootState }, customer) {
    const { companyId: company } = rootState.auth;

    const payload = await api.employees.deleteSingleByCompany(company, customer);

    return payload;
  },

  async getAll({ state, commit, rootState }, { size, page }) {
    const { email } = state;
    const { companyId } = rootState.auth;
    const filters = {};

    if (email) filters.customerEmail = email;

    commit('setValue', { accessor: 'loading', value: true });

    const payload = await api.employees.getAllByCompany(
      companyId, filters, page, size,
    );

    const { count, rows } = payload;

    commit('setValues', {
      count,
      list: rows,
      loading: false,
    });

    return payload;
  },

  async create({ state, rootState }) {
    const { companyId: company } = rootState.auth;

    const { id, ...data } = Object.keys(state).reduce((accum, key) => {
      if (state[key]) set(accum, key, state[key]);
      return accum;
    }, {});

    const { payload } = await api.employees.createByCompany(company, data);

    return payload;
  },

  async update({ state, rootState }) {
    const { companyId: company } = rootState.auth;

    const { id, ...data } = Object.keys(state).reduce((accum, key) => {
      if (state[key]) set(accum, key, state[key]);
      return accum;
    }, {});

    const { payload } = await api.employees.updateSingleByCompany(company, id, data);

    return payload;
  },

  async bulkUpload({ state, commit, rootState }) {
    const { csv } = state;
    const { companyId: company } = rootState.auth;

    const formData = new FormData();
    formData.append('file', csv);

    const payload = await api.employees.bulkUpload(company, formData);

    commit('setValues', { csv: null, csvFileName: '' });
    commit('setValues', {
      list: payload,
      loading: false,
    });

    return payload;
  },
};
